import React, { FC } from 'react';

import { Flex, Box } from 'components/styled';
import Text from 'components/styled/Text';
import Paper from 'components/styled/Paper';

export const StudentProfileSection: FC = ({ children }) => (
	<Paper flexDirection={['column', 'column', 'row']} px={3} my={0}>
		<Flex
			flexBasis={['unset', 'unset', '190px']}
			flexGrow={0}
			flexShrink={0}
			pb={[3, 3, 0]}
		/>
		{children}
	</Paper>
);

const ProfileRow: React.FC<{
	title: string;
	children: React.ReactNode;
}> = ({ title, children }) => (
	<Flex width="100%" my={3} flexDirection={['column', 'column', 'row']}>
		<Box
			flexBasis={['unset', 'unset', '190px']}
			flexGrow={0}
			flexShrink={0}
			pr={[0, 0, 4]}
			pb={[3, 3, 0]}
		>
			<Text as="span" fontWeight="bold" fontSize="xl">
				{title}
			</Text>
		</Box>
		<Box flex={1} pr={[0, 0, 4]} fontSize="md">
			{children}
		</Box>
	</Flex>
);

export default ProfileRow;
